<script setup lang="ts">
import { ref } from "vue"
import { onClickOutside } from "@vueuse/core"

import CopyButton from "@Components/buttons/CopyButton.vue"

import type { ApiToken } from "@Modules/teams/Data/Models/ApiToken"

//
// Props
interface Props {
  token: ApiToken
}

defineProps<Props>()

//
// Emit
interface Events {
  (e: "close"): void
}

const emit = defineEmits<Events>()

//
// Data
const modalRef = ref<HTMLElement | null>(null)

onClickOutside(modalRef, () => {
  close()
})

//
// Methods
function close() {
  emit("close")
}
</script>

<template>
  <div class="modal d-block">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div
        ref="modalRef"
        class="modal-content"
      >
        <div class="modal-body px-4">
          <div class="mt-3 alert alert-warning _token_warning">
            Here is your new API token.
            <strong>
              This is the only time the token will ever be displayed, so be
              sure not to lose it!
            </strong>
            You may revoke the token at any time from your API settings.
          </div>
          <div class="form-group">
            <textarea
              id="api-token"
              :value="token.token ?? ''"
              class="form-control py-2 _token_value"
              rows="2"
              readonly
            />
          </div>
          <div class="form-group">
            <copy-button
              class="btn btn-block btn-teal _copy_token"
              :value="token.token ?? ''"
            >
              Copy To Clipboard
            </copy-button>
          </div>
          <div class="form-group">
            <button
              type="button"
              class="btn btn-block btn-default _close_modal"
              @click="close"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
